import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Calendar from '../../../components/calendar/Calendar.js';
import dayjs from "dayjs";
import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';

function SubAdminReferenceHoliday(props) {
    const [reportdate_filter, setReportdate_filter] = useState(dayjs(new Date()));
    const [datalist, setDatalist] = useState([]);

    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    const onCalendarChange_Filter = (date, dateString) => {
        setReportdate_filter(date)
    };

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    useEffect(() => {
        api_load()
    }, [reportdate_filter]);

    useEffect(() => {
        return () => {
            setDatalist([])
        };
    }, []);

    async function api_load() {
        setmodal_load({ enable: true, message: "Loading holiday list." })
        await sleep(500)

        const formData = new FormData()
        formData.append('year', dayjs(reportdate_filter).format('YYYY'))
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/reference/refholiday/getlist", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {

                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
                if (response.data.holiday !== null && response.data.holiday !== undefined) {
                    setDatalist(response.data.holiday)
                } else {
                    setDatalist([])
                }
            })
            .catch((err) => {
                setDatalist([])
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="fas fa-calendar-alt"></i> Holiday Calendar</h4>
                                    <p className="mb-0">Manage all days of off-peak date</p>
                                </div>
                                <div>
                                    {BackCenter()}
                                </div>
                            </div>
                            <hr className="new-section-xs mb-2" />
                            <div className="d-flex justify-content-start gap-3 mt-2">
                                <button className="btn btn-success btn-sm" onClick={() => { api_load() }}><i className="fas fa-sync-alt"></i> Refresh</button>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3 mb-1 mb-md-4">
                        <div className='d-flex'>
                            <div className="d-block ">
                                <label htmlFor="reporttype" className="form-label mb-0">Select Year Filter</label>
                                <Calendar
                                    allowClear={false}
                                    className={"form-control"}
                                    onChange={onCalendarChange_Filter}
                                    picker={'year'}
                                    style={{
                                        fontFamily: "poppins",
                                        fontSize: "0.75rem",
                                        Color: "black",
                                        lineHeight: "1.5",
                                        cursor: "pointer",
                                    }}
                                    value={reportdate_filter}
                                />
                            </div>
                        </div>

                        <h5 className='mt-3'>Holiday Table (Found {datalist.length} Days)</h5>
                        <div className="table-responsive">
                            <table className="table table-striped table-bordered text-nowrap" >
                                <thead>
                                    <tr className="admintable-header">
                                        <th style={{ width: "50px" }}>#</th>
                                        <th style={{ width: "220px" }}>Date EN</th>
                                        <th style={{ width: "220px" }}>Date TH</th>
                                        <th>Date Description</th>
                                        <th>Edit Time</th>
                                    </tr>
                                </thead>
                                <tbody >
                                    {
                                        datalist?.map((data, index) => (
                                            <tr key={data.datetimestamp}>
                                                <td>{index + 1}</td>
                                                <td><i className="fas fa-calendar-alt rows-icon"></i> {data.datetimestamp_en}</td>
                                                <td><i className="fas fa-calendar-alt rows-icon"></i> {data.datetimestamp_th}</td>
                                                <td>{data.holiday_base ? "วันหยุดประจำสัปดาห์" : data.date_name}</td>
                                                <td>{data.edittime}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}

export default SubAdminReferenceHoliday